/**
 * @generated SignedSource<<6c2dc5aed05eb40902f11552a84939d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFacetFilter_viewer$data = {
  readonly hiddenPhotoSearchBrowseFreetextSearch: boolean | null;
  readonly " $fragmentType": "PhotosSearchBrowseFacetFilter_viewer";
};
export type PhotosSearchBrowseFacetFilter_viewer$key = {
  readonly " $data"?: PhotosSearchBrowseFacetFilter_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilter_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseFacetFilter_viewer",
  "selections": [
    {
      "alias": "hiddenPhotoSearchBrowseFreetextSearch",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "hiddenPhotoSearchBrowseFreetextSearch"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"hiddenPhotoSearchBrowseFreetextSearch\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0a522afd22793cef10a92b46ab46f811";

export default node;
